module.exports = __webpack_public_path__ + "img/chakan.a97e3ab6.svg";